export { FAQCard } from "./FAQCard";
